module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAzklEQVRYhe2U0Q2CMBRFjxs4QkdwAxnBEXQDRmADRsANdAN1AtxAN8ANNCRtQppC5fHJPckLJDS357WlCCGEEEKIVbOZ0bwDCv8MPIE78FmwiA3wAM7WgB1wA74TdQEOhuxikHm0ynUZuWG9gBLYGrLLuXIuCujfa991qApoE6Kd/zYmGss1c+WIJm4zq1L4SVKicVPxuFx2ksoY4EZEx8okh9+CEOr+GJ8SrSfObzgCWaaumf6v2gMnS4cDwtYG3sB14dUkhBBCCCHWAPAD3D5c4QnzAnQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/ic_date@2x.png
// module id = 150
// module chunks = 0